li.container {
  border-radius: 5px;
  border: 0.5px solid #d3e3f7;
  background: rgba(239, 243, 248, 0.4);
  cursor: pointer;
}

li.container:hover {
  border-color: var(--button-primary-color);
  background-color: var(--button-minimal-primary-color);
}

li.container .avatar {
  background: #d3e3f7;
}

li.container .icon {
  color: var(--dark-grey);
}

li.container .item-text span,
li.container .item-text p {
  font-family: inherit;
}

li.container .item-text span {
  font-weight: 500;
}
